import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../../services/api';
import dividuBlue from '../../assets/dividu-blue.svg';

const ForgotPasswordPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            await authService.forgotPassword(email);
            setSuccess(true);
        } catch (err) {
            // Em caso de erro, por segurança, podemos não informar se o email existe ou não,
            // ou podemos mostrar um erro genérico.
            // Para UX, vamos mostrar um erro genérico se falhar muito, mas o backend
            // atualmente não retorna erro se o email não existir (silent fail).
            // Se o backend retornar erro, mostramos:
            setError('Ocorreu um erro. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="auth-page">
                <div className="auth-container">
                    <div className="auth-card">
                        <div className="auth-logo">
                            <img src={dividuBlue} alt="Dividu" style={{ height: '45px', width: 'auto' }} />
                        </div>
                        <h1 className="auth-title">Email enviado!</h1>
                        <p className="auth-subtitle">
                            Verifique sua caixa de entrada. Enviamos um código para <strong>{email}</strong>.
                        </p>

                        <div style={{ textAlign: 'center', marginTop: '24px' }}>
                            <button
                                onClick={() => navigate('/reset-password', { state: { email } })}
                                className="btn btn-primary btn-block btn-lg"
                            >
                                Digitar Código
                            </button>
                        </div>

                        <div className="auth-footer">
                            <Link to="/login">Voltar para o login</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-card">
                    <div className="auth-logo">
                        <img src={dividuBlue} alt="Dividu" style={{ height: '70px', width: 'auto' }} />
                    </div>

                    <h1 className="auth-title">Recuperar Senha</h1>
                    <p className="auth-subtitle">Digite seu email para receber um código de recuperação</p>

                    {error && (
                        <div className="alert alert-error">
                            <span>⚠️</span>
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label className="form-label">Email</label>
                            <input
                                type="email"
                                className="form-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="seu@email.com"
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary btn-block btn-lg"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="loading-spinner" style={{ width: 20, height: 20, borderWidth: 2 }}></span>
                                    Enviando...
                                </>
                            ) : (
                                'Enviar Código'
                            )}
                        </button>
                    </form>

                    <div className="auth-footer">
                        Lembrou a senha?{' '}
                        <Link to="/login">Fazer login</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
